import Vue from 'vue'
import * as nativeApi from '@xunlei/universal-native-api'

Vue.prototype.$native = nativeApi
Vue.prototype.$sentry = {
  // TODO: 临时增加sentry方法，不改写全局
  captureException: err => console.info(err),
}
